import {Pagination, PaginationContent, PaginationItem, PaginationNext, PaginationPrevious} from "@/components/ui/pagination";

type Props = {
  page: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
};

export function AdminPagination({page, totalPages, onPrev, onNext}: Props) {
  return (
    <Pagination className="admin-pagination py-4">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious href="#" onClick={(e) => { e.preventDefault(); if(page > 1) onPrev(); }} className={page <= 1 ? "pointer-events-none opacity-50" : ""} />
        </PaginationItem>
        <PaginationItem>
          <span className="flex h-9 min-w-9 items-center justify-center px-3 text-sm text-muted-foreground">{page} / {totalPages}</span>
        </PaginationItem>
        <PaginationItem>
          <PaginationNext href="#" onClick={(e) => { e.preventDefault(); if(page < totalPages) onNext(); }} className={page >= totalPages ? "pointer-events-none opacity-50" : ""} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
